import React, { useState, useRef } from 'react'
import Logo from './logo'
import NavButtonCta from './navButtonCta'
import NavItem from './navItem'
import useOutsideClick from 'component/OutsideClickHook'
import { items } from './items'
import { itemsButtonsCtas } from './itemsButtonsCta'
import { itemsButtonsCtasTablet } from './itemsButtonsCtaTablet'
import { Location } from '@reach/router'

import './nav.scss'

const Nav = () => {
	const [active, setActive] = useState(false)
	const ref = useRef(null)

	const toggleNav = () => {
		setActive(!active)
	}

	useOutsideClick([ref], () => {
		setActive(false)
	})

	const itemNavRender = (item) => {
		return (
			<li
				className={`nav_item${
					item.class !== undefined ? ` ${item.class}` : ''
				}`}
				key={item.id}
			>
				<NavItem
					type={item.type}
					link={item.link}
					title={item.title}
					subItems={item.subItems}
					className={item.class}
					ulClass={item.ulClass}
					btnClass={item.btnClass}
					id={item.id}
					navToggle={toggleNav}
				/>
			</li>
		)
	}

	return (
		<Location>
			{({ location }) => {
				const pathPage = location.pathname
				// HOME (AURUM) - PAGINA PRINCIPAL
				const isHomePath = pathPage === '/'
				// ASTREA - PAGINAS E SUBPAGINAS
				const isAstreaPath = pathPage === '/astrea/'
				const isAstreaPricesPath = pathPage === '/astrea/planos-e-precos/'
				const isAstrea = isAstreaPath || isAstreaPricesPath
				// THEMIS - PAGINA E SUBPAGINAS
				const isThemisDJPath =
					pathPage === '/themis-para-departamento-juridico/'
				const isThemisEAPath =
					pathPage === '/themis-para-escritorios-de-advocacia/'
				const isThemisCalculatorPath =
					pathPage === '/calculadora-de-prazos-processuais-themis/' ||
					pathPage ===
						'/calculadora-de-prazos-processuais-themis/calendario-de-feriados/'
				const isThemis =
					isThemisDJPath || isThemisEAPath || isThemisCalculatorPath

				const navItemRules = (param) => {
					return param.map((item) => {
						let allPages = item.showOn.includes('all') // use para todas as paginas
						let homePage = item.showOn.includes('home') // use para pagina inicial
						let astreaPage = item.showOn.includes('astrea') // produto Astrea
						let aurumPage = item.showOn.includes('aurum') // use para paginas que nao pertencem a algum produto especifico
						let themisEAPage = item.showOn.includes('themisEA') // produto Themis EA
						let themisDJPage = item.showOn.includes('themisDJ') // produto Themis DJ
						let themisCalculatorPage = item.showOn.includes('themisCalculator') // calculadora de prazos themis
						let subPage = item.showOn.includes('subPage') // use para indicar se menu deve aparecer em uma subpagina

						if (isHomePath && !allPages) {
							if (!homePage && !aurumPage) return null
							return itemNavRender(item)
						}

						if (isAstreaPricesPath && !allPages) {
							if (!subPage) return null
							return itemNavRender(item)
						}

						if (isAstrea && !allPages) {
							if (!astreaPage) return null
							if (isAstreaPricesPath && !subPage) return null
							return itemNavRender(item)
						}

						if (isThemis && !allPages) {
							if (isThemisDJPath && !themisDJPage) return null
							if (isThemisEAPath && !themisEAPage) return null
							if (isThemisCalculatorPath && !themisCalculatorPage) return null
							return itemNavRender(item)
						}

						if (!isHomePath && !isAstrea && !isThemis && !allPages) {
							if (!aurumPage) return null
							return itemNavRender(item)
						} else return itemNavRender(item)
					})
				}

				return (
					<>
						<Logo />
						<NavButtonCta device={['tablet']} data={'out_menu_mobile'}>
							{navItemRules(itemsButtonsCtasTablet)}
						</NavButtonCta>
						<nav ref={ref} className={`nav ${active && 'active'}`}>
							<div className="nav_toggle_container">
								<button className="nav_toggle" onClick={() => toggleNav()}>
									<i className="line_toggle line_one"></i>
									<i className="line_toggle line_two"></i>
									<i className="line_toggle line_three"></i>
								</button>
							</div>
							<div className="nav_list_container">
								<ul className="nav_list">
									{navItemRules(items)}
									<NavButtonCta device={['mobile', 'tablet']}>
										{navItemRules(itemsButtonsCtas)}
									</NavButtonCta>
								</ul>
							</div>
						</nav>
						<NavButtonCta device={['desktop']}>
							{navItemRules(itemsButtonsCtas)}
						</NavButtonCta>
					</>
				)
			}}
		</Location>
	)
}

export default Nav
